import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { AuthContextProvider } from "./context/AuthContext";
import { BrowserRouter } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
// Bootstrap Bundle JS
import "bootstrap/dist/js/bootstrap.bundle.min";
import PathnameProvider from "./context/PathnameProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
window.convertir = require("numero-a-letras");
root.render(
  <AuthContextProvider>
    <PathnameProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
    </PathnameProvider>
  </AuthContextProvider>
);
